export default __webpack_public_path__ + "static/char-02-anr-bbf5702c3620de23a23cccd9aa5924f5.webp";